export default {
  user: null,
  token: null,
  module: null,
  heartbeatIntervalId: null,
};
